module.exports = __webpack_public_path__ + "2ea33cdd3b0a164ec85225cfc08fe4d4.svg";